<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="form-group">
            <label for="vendorName">Name</label>
            <input id="vendorName" type="text" class="form-control" [(ngModel)]="target.name" name="name" required />
            <small class="form-text text-muted">Display name for this location (e.g. Big O – Vernal).</small>
        </div>

        <div class="form-group">
            <label for="vistaSource">Contact source</label>
            <wj-combo-box
                id="vistaSource"
                [(ngModel)]="source"
                name="vistaSource"
                [itemsSource]="sourceOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                (selectedIndexChanged)="onSourceChanged()"
            ></wj-combo-box>
        </div>

        @if (source !== 'local') {
            <div class="row align-items-end mb-2">
                <div class="col-md-9">
                    <div class="form-group mb-0">
                        <label for="vistaSearch">Search Vista</label>
                        <input
                            id="vistaSearch"
                            type="text"
                            class="form-control"
                            [(ngModel)]="searchTerm"
                            name="vistaSearch"
                            placeholder="{{ source === 'apVendor' ? 'e.g. Big O' : 'e.g. Discount Tire' }}"
                            (keyup.enter)="search()"
                        />
                    </div>
                </div>
                <div class="col-md-3">
                    <button type="button" class="btn btn-outline-primary w-100" (click)="search()" [disabled]="isSearching || !searchTerm.trim()">
                        @if (isSearching) {
                            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
                        } @else {
                            Search
                        }
                    </button>
                </div>
            </div>

            @if (source === 'apVendor' && vendorResults().length) {
                <div class="list-group mb-3" style="max-height: 180px; overflow-y: auto">
                    @for (row of vendorResults(); track row.vendor) {
                        <button
                            type="button"
                            class="list-group-item list-group-item-action"
                            [class.active]="selectedVendor?.vendor === row.vendor"
                            (click)="selectVendor(row)"
                        >
                            <div class="fw-semibold">{{ row.name }}</div>
                            <small class="text-muted">
                                {{ row.city }}{{ row.city && row.state ? ', ' : '' }}{{ row.state }}
                                @if (row.phone) {
                                    · {{ row.phone }}
                                }
                            </small>
                        </button>
                    }
                </div>
            }

            @if (source === 'firmContact' && firmResults().length) {
                <div class="list-group mb-2" style="max-height: 160px; overflow-y: auto">
                    @for (row of firmResults(); track row.firmNumber) {
                        <button
                            type="button"
                            class="list-group-item list-group-item-action"
                            [class.active]="selectedFirm?.firmNumber === row.firmNumber"
                            (click)="selectFirm(row)"
                        >
                            <div class="fw-semibold">{{ row.name }}</div>
                            <small class="text-muted">
                                {{ row.firmType }}
                                @if (row.city) {
                                    · {{ row.city }}
                                }
                                · {{ row.contacts.length || 0 }} contacts
                            </small>
                        </button>
                    }
                </div>
            }

            @if (source === 'firmContact' && selectedFirm) {
                <div class="form-group">
                    <label for="firmContact">Firm contact</label>
                    <wj-combo-box
                        id="firmContact"
                        [(ngModel)]="target.vistaFirmContactCode"
                        name="firmContact"
                        [itemsSource]="firmContactOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (selectedIndexChanged)="onFirmContactChanged()"
                    ></wj-combo-box>
                    <small class="form-text text-muted">Optional — leave blank to use the firm-level phone/email.</small>
                </div>
            }
        }

        <div class="alert alert-light border small mb-3">
            <div><strong>Resolved contact</strong> ({{ previewSource }})</div>
            <div>Location: {{ previewLocation }}</div>
            <div>Contact: {{ previewContactName }}</div>
            <div>Phone: {{ previewPhone }}</div>
            <div>Email: {{ previewEmail }}</div>
        </div>

        <div class="form-group">
            <label for="contactName">Fallback contact name</label>
            <input id="contactName" type="text" class="form-control" [(ngModel)]="target.contactName" name="contactName" />
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="phone">Fallback phone</label>
                    <input id="phone" type="tel" class="form-control" [(ngModel)]="target.phone" name="phone" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="email">Fallback email</label>
                    <input id="email" type="email" class="form-control" [(ngModel)]="target.email" name="email" />
                </div>
            </div>
        </div>
        <small class="form-text text-muted d-block mb-3">
            Fallback fields are used only when no Vista link is set, or the Vista row is missing.
        </small>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
